import { render, staticRenderFns } from "./SwfPlayer.vue?vue&type=template&id=6a2c4fa6&scoped=true&"
import script from "./SwfPlayer.vue?vue&type=script&lang=js&"
export * from "./SwfPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c4fa6",
  null
  
)

export default component.exports